import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons'
import { faBatteryFull, faBatteryThreeQuarters, faBatteryHalf, faBatteryQuarter, faBatteryEmpty,
         faExclamationTriangle, faQuestionCircle}
        from  '@fortawesome/free-solid-svg-icons'
import {nestedPropertyOrNull, nestedProp} from '../Utils/object.js';
import { dateObjSort } from './helperfunctions.js';
import {isNumeric} from './Model/isType.js'

export function RowOfChildren (props) {
  // console.log (props.children)
  const kids = props?.children ?? []
  const flat = Array.isArray(kids) ? kids.flat(Infinity) : kids
  return (
    <tr className="csv-tr">
      {flat.map((item, index) => item?.props?.asis ? item :
        item?.props.className ? <td key={index}>{item}</td> :
          (<td className="csv-td" key={index} id={props?.id}>{item}</td>))}
    </tr>
  )
}
export function GridText (props) {
  return props?.value ?? ''
}
export function BodyRow(props) {
  const device = props.data;
  const colSeq = props.colSeq;
  const handleClicks = props.graph ? props.graph : null;
  const rowClass = handleClicks ? "csv-tr csv-point" : "csv-tr"
  const bf = props.batteryFormat ? props.batteryFormat : 0;
  const dec = props?.decimals
  const vis = props?.visual ?? '';
  if (device && colSeq.length > 0) {
    return (<tr className={rowClass} onClick={handleClicks} >
      {props.deco ? props.deco(props) : null}
      {colSeq.map((colName, index) => (colName.length > 0 ?
        <td className={"csv-td "+vis} id={colName} key={colName}> 
         {colName.endsWith('BattVolt') && bf === 0 ? RenderBattVolt(nestedPropertyOrNull(device, colName)) :
          renderText(device, colName, dec && dec[index])} </td> : null))}
    </tr>);
  }
  else if (device) {
    return (<tr className="csv-tr">
      {Object.keys(device).map(key => <td className="csv-td" key={key}> {device[key]} </td>)}
    </tr>);
  }
  else {
    return null;
  }
}
function renderText (device, colName, decimals) {
  const inc = nestedPropertyOrNull(device, colName)
  if (inc && decimals && decimals > -1) {
    return inc.toLocaleString (undefined, { minimumFractionDigits: decimals });
  }
  return inc
}
export function numberToDisplay (num, format) {
  return num?.toLocaleString(undefined, { maximumFractionDigits: format})
}
/// gotta keep these 2 fns in sync
export function BatteryIcons () {
  return [faBatteryFull, faBatteryThreeQuarters, faBatteryHalf, faBatteryQuarter, faBatteryEmpty, faExclamationTriangle, faQuestionCircle];
}

export function BatteryVoltages() {
  return [3.0, 2.8, 2.6, 2.4, 2.2, 2.1];
}
  
export function RenderBattVolt(volts, size='lg') {
  const batts = BatteryIcons();
  const colors = ['#18BC9C', '#e2ca00', '#e2ca00',  '#F39C12', '#E74C3C', '#E74C3C', '#212529']
  if (isNaN(volts) || null === volts) {
    return <FontAwesomeIcon icon={faQuestionCircle} color='#212529' size="lg" />
  }
  const stages = BatteryVoltages();
  const indx = stages.findIndex((s, index) => {return index < stages.length -1 ? volts >= s : true})
  return <FontAwesomeIcon icon={batts[indx]} color={colors[indx]} size={size} />
}

export function TitleRow(props) {
  const index = props?.index ?? 0;
  if (index===0) {
    const device = props.data;
    const colName = props?.colName ?? props.displayName;
    const jsonKey = props?.colSeq ?? props?.displayOrder;
    const handleClicks = props.graph ? props.graph : null;
    const colSort = props.colSort;
    var sortableCols = new Array (colName.length);
    sortableCols = props.sortable ? props.sortable : sortableCols.fill (true, 0, colName.length);
    const specialFirstCol = (typeof props.deco === 'function')
    if (colName && colName.length > 0) {
      if (colSort)
        return (<tr className="csv-tr" onClick={handleClicks}>
          {colName.map((name, index) => sortableCols[index] ? 
            sortableColumnTH(name, index, jsonKey, colSort) :
            index === 0 && specialFirstCol ? props.deco() : nonSortableColumnTH(name, index, jsonKey)) }
          </tr>)
      else
        return (<tr className="csv-tr">
          {colName.map((name, index) => nonSortableColumnTH(name,  index, jsonKey)) }
        </tr>)
    }
    else return (<tr className="csv-tr">
      {Object.keys(device).map(key => <th className="csv-td">{key}</th> )}
      </tr>)
  }
  return null;
}

function sortableColumnTH(name, index, jsonKey, colSort) {
  const icons = [faSort, faSortUp, faSortDown];
  return <th className="csv-th-sortable" id={jsonKey[index]} key={jsonKey[index]}>
  {name} <FontAwesomeIcon icon={icons[colSort[index]]} color="#888" /></th>
}

function nonSortableColumnTH(name, index, jsonKey) {
  return <th className="csv-th" id={jsonKey[index]} key={jsonKey[index]}>{name}</th>
}
export function newSortIndicators (indicatorCount) {
  return new Array(indicatorCount).fill(0);
}
export function clearSortIndicators (arrInds){
  return arrInds.fill(0)
}
export function setSortIndicator (targ, arrToSort) {
  const temp = arrToSort[targ?.cellIndex];
  if (!isNaN(temp)) {
    arrToSort[targ.cellIndex] = temp === 2 ? 1 : temp+1;
  }
  return arrToSort;
}
export function flipIndicator (targ, arrInds, lastCol) {
  const column = targ.id.trim();
  const arrows = lastCol === column ? arrInds : clearSortIndicators(arrInds)
  return setSortIndicator (targ, arrows)
}
export function flipSort (arrData, prop, lastProp) {
  if (!Array.isArray(arrData)) return
  if (prop === lastProp)
    arrData.reverse()
  else {
    arrData[0][prop]?.getTime ? dateObjSort(arrData, prop) : coreSort(arrData, prop)
  }
}
export function coreSort (arrData, prop) {
  arrData.sort(function(a,b) {
    const x = nestedProp(a, prop) ?? ''
    const y = nestedProp(b, prop) ?? ''
    if (typeof x === 'number' && typeof y === 'number') 
      return (x-y);
    if(isNumeric(x) && isNumeric(y))
      return (x-y)
    else
      return x.localeCompare(y);
  });
}
// returns the parent th or td element of what was clicked
export function clickToTableTarget (e) {
  let targ;
  if (e.target) targ = e.target;
  else if (e.srcElement) targ = e.srcElement;
  if (targ.nodeType === 3) // defeat Safari bug
    targ = targ.parentNode;
  while (false === ("cellIndex" in targ)) {   // get back to the table element
    targ = targ.parentElement;
  }
  //alert ("you clicked " + targ.innerText + " row " + targ.parentElement.rowIndex);
  return targ;
}
export function clickToNamedClass (e, name) {
  let targ;
  if (e.target) targ = e.target;
  else if (e.srcElement) targ = e.srcElement;
  if (targ.nodeType === 3) // defeat Safari bug
    targ = targ.parentNode;
  while (targ && false === (name === targ.className)) {
    targ = targ.parentElement;
  }
  //alert ("you clicked " + targ.innerText + " row " + targ.parentElement.rowIndex);
  return targ;
}
// always pass hex radio id
export function formatRadioId(radioid, fmt) {
  if (fmt === 0) return radioid.toUpperCase();
  else return parseInt (radioid, 16).toString();
}

export function formatTable (jsonData, deviceField, formatWanted) {
  if (!jsonData) return jsonData;

  const fmt = jsonData.map((item) => {
    item[deviceField] = formatRadioId (item[deviceField], formatWanted)
    return item
  })
  return fmt
}
export function toVolts (data, prop) {
  return data.map (i => {
    const v = Number(nestedProp(i, prop))
    const o = isNaN(v) ? {} : {volt: Math.round(v/10)/100} 
    return {...i, ...o}
  })
}
